<template>
  <div class="info-banner" v-if="this.show">
    <h4>{{ this.heading }}</h4>
    <p>{{ this.body }}</p>
  </div>
</template>

<script>
// Set this to false to hide the banner
const SHOW_BANNER = false
const body = {
  au:
    'If you’re in Australia or the Rest of World you’re in the right place! For our North American customers, select your region in the footer.',
  us:
    'If you’re in US or Canada you’re in the right place! For our Australian and Rest of World customers, select your region in the footer.',
}

export default {
  data() {
    return {
      show: SHOW_BANNER,
      heading: 'GIA is now a world traveller.',
      body: body[REGION],
    }
  },
}
</script>